import React from 'react';
import styled from 'styled-components';

const StyledDiv = styled.div`
  cursor: pointer;
  user-select: none;
  -webkit-tap-highlight-color: rgba(0,0,0,0);
  will-change: transform, opacity;

  &.message-enter {
    transition: opacity .3s;
    opacity: 0.01;
  }

  &.message-enter.message-enter-active {
    opacity: 1;
  }

  &.reseting {
    transition: transform .1s, opacity .1s;
  }
`;

class SwipeBox extends React.Component {
  constructor(props) {
    super(props);
    this.startHandler = this.mapEventToHandler(this.handleStart);
    this.moveHandler = this.mapEventToHandler(this.handleMove);
    this.endHandler = this.mapEventToHandler(this.handleEnd);
    this.ongoingTouches = {};
  }
  mapEventToHandler(handler) {
    // this normalizes touch and mouse events
    // to isolate individual swipes and share code.
    return (e) => {
      const touches = e.changedTouches;
      if (touches) {
        for (let i = 0; i < touches.length; i++) {
          handler(touches[i]);
        }
      } else {
        handler({ ...e, identifier: 'mouse' });
      }
    }
  }
  updateTouch(touch, isSwiping, startX) {
    const identifier = touch.identifier;
    this.ongoingTouches[identifier] = {
      startX: startX || this.ongoingTouches[identifier].startX,
      isSwiping: typeof isSwiping !== undefined ?
        isSwiping : this.ongoingTouches[identifier].isSwiping,
    };
  }

  handleStart = (start) => {
    this.node.classList.remove('reseting');
    this.updateTouch(start, false, start.pageX);
  }

  handleMove = (move) => {
    const identifier = move.identifier;
    const ongoingTouch = this.ongoingTouches[identifier];

    if (ongoingTouch) {
      const diff = move.pageX - ongoingTouch.startX;
      if (ongoingTouch.isSwiping) {
        let proportion = (this.props.threshold - diff) / this.props.threshold;
        const opacity = Math.min((proportion * .4) + .6, 1);
        const scale = Math.min((proportion * .05) + .95, 1);
        this.node.style.transform = `translateX(${diff}px) scale(${scale})`;
        if (proportion < 1) {
          if (this.props.threshold - diff < 0) {
            this.node.style.opacity = 0.4;
          } else {
            this.node.style.opacity = Math.max(opacity, 0.6);
          }
        }
      } else if (diff > 50) {
        this.updateTouch(move, true);
      }
    }
  }

  handleEnd = (end) => {
    const identifier = end.identifier;
    const ongoingTouch = this.ongoingTouches[identifier];

    if (ongoingTouch) {
      this.node.classList.add('reseting');
      if (end.pageX - ongoingTouch.startX > this.props.threshold) {
        const diff = end.pageX - ongoingTouch.startX;
        this.node.style.opacity = 0;
        this.node.style.transform = `translateX(${diff * 1.5}px)`;
        this.props.onSwiped(this.props.id);
      } else {
        this.node.style.opacity = '';
        this.node.style.transform = '';
      }
      delete this.ongoingTouches[identifier];
    }
  }

  render() {
    return (
      <StyledDiv
        innerRef={((node) => this.node = node)}
        onTouchStart={this.startHandler}
        onMouseDown={this.startHandler}
        onTouchMove={this.moveHandler}
        onMouseMove={this.moveHandler}
        onTouchEnd={this.endHandler}
        onTouchCancel={this.endHandler}
        onMouseUp={this.endHandler}
        onMouseLeave={this.endHandler}
      >
        {this.props.children}
      </StyledDiv>
    );
  }
};

SwipeBox.defaultProps = {
  threshold: 150,
};

export default SwipeBox;



// WEBPACK FOOTER //
// ./src/SwipeBox.js